<template>
  <div
    v-if="canRead || isTenant"
    class="insurance"
  >
    <Collapse class="insurance__collaspe">
      <div
        slot="title"
        class="insurance__collaspe-title-box"
      >
        <span class="insurance__collaspe-title default-title">
          {{ $t('tenantProjects.insurance.title') }}
        </span>
        <span
          v-if="initInsurance.startDate && initInsurance.endDate"
          class="insurance__collaspe-status float-right"
        >
          <i class="insurance__collaspe-status_check fa fa-check" />
          {{ $t('tenantProjects.insurance.validFrom', [$options.filters['formatDate'](initInsurance.startDate, 'DD MMM YYYY'), $options.filters['formatDate'](initInsurance.endDate, 'DD MMM YYYY')]) }}
        </span>
      </div>
      <div
        slot="content"
        class="insurance__collaspe-content"
      >
        <div class="insurance__collaspe-content-header">
          <div>
            <div :class="[{'required-flag': isEngineer && canUpdate}, 'blod-p']">
              {{ $t('tenantProjects.insurance.coveragePeriod') }}
            </div>
            <div
              v-if="insurance.updater"
              class="last-update"
            >
              <div class="last-update__text">
                {{ $t('lastUpdatedBy', [insurance.updater.displayName, $options.filters['formatDate'](insurance.updatedAt, 'DD MMM YY HH:mm')]) }}
              </div>
            </div>
          </div>
          <div
            v-if="isEngineer && canUpdate && !isWithdrawn"
            class="btn-group"
          >
            <button
              class="btn btn--darkblue"
              @click="confirm()"
            >{{ $t('action.confirm') }}</button>
          </div>
          <div
            v-if="isTenant && isAppendFile"
            class="btn-group"
          >
            <button
              class="btn btn--darkblue"
              @click="tenantConfirm()"
            >{{ $t('action.confirm') }}</button>
          </div>
        </div>
        <div
          id="insuranceFrom"
          class="inline-block"
        >
          <label class="inline-block__item">{{ $t('tender.attachment.effectiveFrom') | capitalize }}</label>
          <DatePicker
            v-if="isEngineer && canUpdate"
            class="inline-block__item"
            :calendarButton="true"
            calendarButtonIcon="fa fa-calendar"
            :required="true"
            :value="insurance.startDate | formatDate"
            :disabledPicker="isWithdrawn"
            :disabled="{ from: insurance.endDate ? new Date(insurance.endDate) : null }"
            @selected="val => insurance.startDate = val"
          />
          <span
            v-else
            class="inline-block__item"
          >
            {{ (insurance.startDate) | formatDate | isEmptyValue }}
          </span>
          <label class="inline-block__item">{{ $t('dateTo') | capitalize }}</label>
          <DatePicker
            v-if="isEngineer && canUpdate"
            class="inline-block__item"
            :calendarButton="true"
            calendarButtonIcon="fa fa-calendar"
            :required="true"
            :value="insurance.endDate | formatDate"
            :disabledPicker="isWithdrawn"
            :disabled="{ to: insurance.startDate ? new Date(insurance.startDate) : null }"
            @selected="val => insurance.endDate = val"
          />
          <span
            v-else
            class="inline-block__item"
          >
            {{ (insurance.endDate) | formatDate | isEmptyValue }}
          </span>
        </div>
        <p class="insurance__doc-title blod-p">
          {{ $t('tenantProjects.insurance.document') }}
        </p>
        <p
          v-if="canEdit"
          class="insurance__doc-hint"
        >
          {{ $t('tenantProjects.insurance.documentHint') }}
        </p>
        <HkldDropzone
          v-if="canEdit"
          class="uploadfileszone"
          :sourceId="sourceId"
        />
        <EditAttachments
          ref="editAttachments"
          :sourceId="sourceId"
          :canDownloadAll="false"
          :canEdit="canEdit"
          :canDelete="canEdit"
          :showAllDeleteBtn="false"
          :showDeleteBtnFunc="showAttachmentsDelBtn"
          :updateDescriptionCb="setTenantUpdatedAt"
          :deleteFileCb="setTenantUpdatedAt"
          :uploadSuccessCb="setTenantUpdatedAt"
        />
      </div>
    </Collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Collapse from '@/controls/Collapse'
import DatePicker from '@/controls/DatePicker'
import EditAttachments from '@/controls/EditAttachments'
import HkldDropzone from '@/controls/HkldDropzone'

import EventBus from '@/utils/eventBus'
import * as insuranceAPI from '@/api/insurance/request'
import { aclHelper, tmsPermsTypes } from '@/utils/aclHelper'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'

export default {
  name: 'Insurance',
  components: {
    Collapse,
    DatePicker,
    EditAttachments,
    HkldDropzone,
  },
  data () {
    const initInsurance = {
      id: '',
    }
    return {
      projectId: this.$route.params.id,
      initInsurance,
      insurance: this.clone(initInsurance),
    }
  },
  computed: {
    ...mapGetters('user', ['currentUser', 'isEngineer', 'isTenant']),
    ...mapGetters('tenantProject', ['isWithdrawn']),
    sourceId () {
      return this.insurance.id || ''
    },
    canRead () {
      return aclHelper.getAccess(tmsPermsTypes.project.readInsurance)
    },
    canUpdate () {
      return aclHelper.getAccess(tmsPermsTypes.project.updateInsurance)
    },
    canEdit () {
      return !this.isWithdrawn && (this.canUpdate || this.isTenant)
    },
    latestComfirmedAt () {
      let tenantConfirmedAt = new Date(this.insurance.tenantConfirmedAt)
      let hklConfirmedAt = new Date(this.insurance.updatedAt)
      return tenantConfirmedAt > hklConfirmedAt ? tenantConfirmedAt : hklConfirmedAt
    },
    isAppendFile () {
      return this.latestComfirmedAt && this.$refs['editAttachments'] && this.$refs['editAttachments'].files.some(
        file => file.creator.id === this.currentUser.id &&
        new Date(file.createdAt) > this.latestComfirmedAt)
    },
  },
  created () {
    if (this.canRead || this.isTenant) {
      this.init()
    }
  },
  methods: {
    clone (data) {
      return Object.assign({}, data)
    },
    validate () {
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '#insuranceFrom')
      const fusionValidResult = fusionInputCheckUtil.isAllFieldsValid('#insuranceFrom')
      return fusionValidResult
    },
    async init () {
      const result = await insuranceAPI.get({ projectId: this.projectId })
      if (result.length === 0) {
        this.initInsurance = await insuranceAPI.create({ projectId: this.projectId })
        this.initInsurance.startDate = ''
        this.initInsurance.endDate = ''
      } else {
        this.initInsurance = result[0]
      }
      this.insurance = this.clone(this.initInsurance)
      EventBus.$emit('updateInsurance', this.insurance)
    },
    async confirm () {
      if (!this.validate()) return
      this.insurance.projectId = this.projectId
      const request = {
        startDate: this.insurance.startDate,
        endDate: this.insurance.endDate,
        projectId: this.projectId,
      }
      const result = await insuranceAPI.update(this.insurance.id, request)
      if (result.id) {
        this.initInsurance = this.clone(result)
        this.insurance = this.clone(result)
        EventBus.$emit('updateInsurance', this.insurance)
      }
    },
    showAttachmentsDelBtn (item) {
      let result = false
      if (this.insurance.updatedAt < item.createdAt) {
        result = this.currentUser.id === item.createdBy
      }
      return result
    },
    async setTenantUpdatedAt () {
      if (this.isTenant) {
        const updateFieldData = {
          tenantUpdatedAt: new Date(),
        }
        if (!this.$refs['editAttachments'].files.length > 0) {
          updateFieldData.tenantConfirmedAt = null
          updateFieldData.tenantConfirmedBy = null
          updateFieldData.tenantUpdatedAt = null
        }
        this.insurance = {...this.insurance, ...updateFieldData}
        await insuranceAPI.update(this.insurance.id, updateFieldData)
      }
    },
    async tenantConfirm () {
      const request = {
        tenantConfirmedAt: new Date(),
        tenantConfirmedBy: this.currentUser.id,
      }
      await insuranceAPI.update(this.insurance.id, request)
      this.insurance.tenantConfirmedAt = request.tenantConfirmedAt
      this.insurance.tenantConfirmedBy = request.tenantConfirmedBy
    },
  },
}
</script>

<style lang="scss" scoped>
.last-update {
  margin: 0 0 5px;
}
.insurance__collaspe-content-header {
  .vdp-datepicker {
    vertical-align: middle;
  }
}
.inline-block {
  &__item {
    display: inline-block;
    font-weight:normal;
    vertical-align: baseline;
    & + & {
      margin-left: 5px
    }
  }
}
.uploadfileszone {
  margin-top: 15px
}
.insurance {
  &__collaspe-content {
    padding: 15px;
    &-header {
      display: flex;
      justify-content: space-between;
    }
  }
  &__collaspe {
    &-status {
      color: #3ba04d;
      margin-right: 30px;
    }
    &-status_check {
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 50%;
      background-color: #3ba04d;
      color: #ffffff;
      text-align: center;
      margin-right: 10px;
    }
  }
  &__create-btn {
    margin-bottom: 15px;
  }
  margin-top: 20px;
  &__doc-title {
    margin-top: 15px;
  }
  &__doc-hint {
    margin-bottom: 15px;
  }
  .uploadfileszone {
    margin-top: 0
  }
}
.text-field {
  label, &.remarks ::v-deep label {
    font-weight: bold;
    line-height: 20px;
    margin: 15px 0 10px;
  }
}
.remarks {
  & ::v-deep .text-input textarea {
    min-height: 95px
  }
}
.modal-header {
  font-weight: bold
}
</style>
